export default "__VITE_ASSET__BohItXAc__"